<template>
  <div>
    <CustomerInfo v-bind:customer="customer" :loaded="customerLoaded" />

    <div v-if="customerLoaded">
      <CustomerHistory
        @change-tab="tab = $event"
        :history="customer.history"
        :discounts="discounts"
      />
      <div class="grid gap-4 px-4 sm:px-6 lg:mx-auto lg:px-8 grid-cols-3">
        <div class="col-span-3">
          <CustomerOrders v-show="tab === 'orders'" :customer="customer" />
          <CustomerDiscounts
            v-show="tab === 'discounts'"
            @discounts="discounts = $event"
            :customer="customer"
          />
        </div>
      </div>
    </div>

    <!-- No Customer loaded -->
    <div v-else>
      <div v-if="customerSearching" class="flex items-center space-x-2">
        <span>Searching</span>
        <LoadingSpinner class="text-gray-400" />
      </div>
      <div v-else>No Customer Loaded</div>
    </div>
  </div>
</template>
<script>
/**
 * TODO
 */
import CustomerInfo from "./components/CustomerInfo.vue";
import CustomerHistory from "./components/CustomerHistory.vue";
import CustomerOrders from "./components/CustomerOrders.vue";
import CustomerDiscounts from "@/views/Customers/components/CustomerDiscounts.vue";

export default {
  name: "Details",
  data() {
    return {
      slideoverVisibleEdit: false,
      slideoverVisibleSearch: false,
      customerHistory: {},
      tab: "orders",
      discounts: null,
    };
  },
  props: {
    customerId: {
      type: Number,
      default: null,
    },
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch("customers/fetchCustomer", this.$route.params.id);
    }
  },
  components: {
    CustomerDiscounts,
    CustomerInfo,
    CustomerHistory,
    CustomerOrders,
  },
  computed: {
    customerLoaded() {
      return this.$store.getters["customers/isCustomerLoaded"];
    },
    customerSearching() {
      return this.$store.getters["customers/isCustomerSearching"];
    },
    customer() {
      return this.$store.getters["customers/getCustomer"];
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {},
  filters: {},
};
</script>
